import React from 'react';

import TextFieldInput from '../Text';

// TODO: use search by name/email

export default function Email(props) {
    props.field.options = props.field.options || {};
    props.field.options.regexp = '^[0-9a-zA-Z]*$';
    return <TextFieldInput {...props}/>
}





// import React, {useEffect, useState} from 'react';

// import TextField from '@mui/material/TextField';

// import {useFormStore} from '../../../Stores/form';

// export default function User(props) {
//     const {content, disabled, field, isEditMode, onChange} = props;

//     const {formVisibleErrors} = useFormStore();
//     const showErrorText = formVisibleErrors[field.id];

//     const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
//     useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

//     return (<>
//         <TextField
//             error={Boolean(showErrorText)}
//             helperText={showErrorText}
//             fullWidth
//             value={content[field.id] || ''}
//             required={field.required}
//             label={field.placeholder}
//             variant="outlined"
//             onChange={onChange}
//             disabled={isDisabled}
//             // InputProps={{maxLength: field?.options?.maxLength}}
//         />
//         {!showErrorText && field?.options?.maxLength && <div className='fieldNotes'>
//             <p>* максимальна кількість символів - {field?.options?.maxLength}</p>
//         </div>}
//     </>)
// }
